<template>
  <PaginationButtonDigit
    :page="1"
    @click="changePage(1)"
  />

  <PaginationButtonDots />

  <PaginationPagesRange
    :start="startOfButtons"
    :end="endOfButtons"
    :current-page="currentPage"
    @page-change="changePage($event.page)"
  />

  <PaginationButtonDots />

  <PaginationButtonDigit
    :page="totalPages"
    @click="changePage(totalPages)"
  />
</template>

<script>
import ChangePageMixin from "../mixins/ChangePageMixin.js";
import PagePropsMixin from "../mixins/PagePropsMixin.js";
import PaginationButtonDigit from "./PaginationButtonDigit.vue";
import PaginationButtonDots from "./PaginationButtonDots.vue";
import PaginationPagesRange from "./PaginationPagesRange.vue";

export default {
  name: "PaginationActiveMiddle",
  components: { PaginationPagesRange, PaginationButtonDots, PaginationButtonDigit },
  mixins: [
    ChangePageMixin,
    PagePropsMixin,
  ],
  props: {
    startOfButtons: {
      type: Number,
      required: true,
    },
    endOfButtons: {
      type: Number,
      required: true,
    }
  },
}
</script>
